import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { addToCart, removeItemFromCart } from '../../redux/cart/cart.action';
import { selectCartItem } from '../../redux/cart/cart.selector';

import Delete from '../../assets/Delete.png';
import './cart-button.styles.css';


const cartButton = ({ item,addToCart,removeItem,cartItemdetails }) => {
    
    if (cartItemdetails) { 
        return (
            <div>

                <div className='uk-flex uk-flex-left cart-button-container' >
                    <button className='uk-height-1-1 uk-padding-remove cart-button-split'  onClick={() => {removeItem(item);window.navigator.vibrate(50);}}>{cartItemdetails.quantity === 1 ? <p style={{ paddingBottom: '2px' }}><img src={Delete} alt='deleteicon' className="cart-delete-icon" /></p> : '-'}</button>
                    <div className='uk-margin-remove uk-text-center cart-qty'>{cartItemdetails.quantity}</div>
                    <button className='uk-height-1-1 uk-padding-remove cart-button-split' onClick={() => {addToCart(item);window.navigator.vibrate(50);}}>+</button>
                </div>

            </div>
        )
    }

    return (
        <div>
            <button onClick={() => {addToCart(item);window.navigator.vibrate(50);}} className='cart-button'>ADD&nbsp;&nbsp;&nbsp;+</button>
        </div>
    )

}

const mapStateToProps = (state, ownProps) => createStructuredSelector({
    cartItemdetails: selectCartItem(ownProps.item.id)
})

const mapDispatchToProps = dispatch => ({
    addToCart: item => dispatch(addToCart(item)),
    removeItem : item => dispatch(removeItemFromCart(item))
})


export default connect(mapStateToProps, mapDispatchToProps)(cartButton);